import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Marker from '../Marker'
import CompanyAvatar from '../Marker/CompanyAvatar'
import { introImageGroupSelector } from '../../redux/selector'
import { animation } from '../Marker/CompanyAvatar'

const AvatarMarker = styled(Marker)`
  transition: all ${({ duration }) => duration}ms ease-in-out;
  z-index: ${({ isCurrent, start }) => (isCurrent ? 3000 : start)};
`

class AvatarLayer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      group: 0,
      item: null,
    }
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      if (this.props.companies.length > 0) {
        this.setState(({ group, item }) => {
          const itemCount = this.props.companies[group].items.length
          const init = item === null
          if (init || item < itemCount) {
            return {
              item: init ? 0 : item + 1,
            }
          }

          return {
            group: (group + 1) % this.props.companies.length,
            item: null,
          }
        })
      }
    }, 4000)
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  render() {
    const { companies, size, multiplier } = this.props
    const { group, item } = this.state

    if (companies.length < 1) return null
    return companies[group].items.map((company, i) => {
      const { id, position, avatar, introImage, start } = company
      const { lat, lng } = position
      const { url } = introImage
      const isCurrent = i === item

      return (
        <AvatarMarker
          key={`image-marker-${id}`}
          latitude={lat}
          longitude={lng}
          captureDrag={false}
          isCurrent={isCurrent}
          start={start}
          duration={animation.duration}
          size={multiplier * size}
        >
          <CompanyAvatar
            image={url}
            size={isCurrent ? size * multiplier : size}
            imageSize={size * multiplier}
            show={avatar}
            placeholder={false}
          />
        </AvatarMarker>
      )
    })
  }
}

AvatarLayer.defaultProps = {
  companies: [],
  size: 112,
  multiplier: 2,
}

const mapStateToProps = state => ({
  companies: introImageGroupSelector(state),
})

export default connect(mapStateToProps)(AvatarLayer)
